import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ContainerStyled from './style/BuyingStyled';
import Header from './Header/Header';
import Content from './Content/Content';
import PaymentMethods from './PaymentMethods/PaymentMethods';
import useSegment from '../../../../hooks/useSegment';
import useOtherLines from '../../../../hooks/useOtherLines';
import BalanceWarning from './BalanceWarning/BalanceWarning';

const Buying = ({
  bundleData,
  balance,
  wompayCard,
  buyCallback,
  disabledMethods,
  paymentType,
  fromOtherLines,
}) => {
  const buyHandler = method => buyCallback(method, bundleData);
  const [disabled, setDisabled] = useState(false);
  const { credit } = useOtherLines();
  const { creditAvailable } = credit;

  const { segment } = useSegment();
  useEffect(() => {
    if (fromOtherLines) {
      if (Number(creditAvailable) > Number(bundleData.price)) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    }
  }, [creditAvailable]);

  return (
    <ContainerStyled>
      <Header
        name={bundleData.offerName}
        description={bundleData.description}
        code={bundleData.code}
      />
      <Content
        effectDate={bundleData.effectDate}
        expirationDate={bundleData.expirationDate}
        price={bundleData.price}
      />
      {bundleData.price > balance && segment.toUpperCase() !== 'POSTPAID' && (
        <BalanceWarning />
      )}
      <PaymentMethods
        buyCallback={buyHandler}
        availableMethods={bundleData.paymentMethods}
        disabledMethods={disabledMethods}
        segment={segment}
        balance={balance}
        wompayCard={wompayCard}
        bundlePrice={bundleData.price}
        disabled={disabled}
        paymentType={paymentType}
      />
    </ContainerStyled>
  );
};

Buying.propTypes = {
  bundleData: PropTypes.shape({
    code: PropTypes.string,
    description: PropTypes.string,
    effectDate: PropTypes.string,
    expirationDate: PropTypes.string,
    name: PropTypes.string,
    offerCode: PropTypes.string,
    offerName: PropTypes.string,
    paymentMethods: PropTypes.arrayOf(PropTypes.string),
    price: PropTypes.string,
    validity: PropTypes.string,
  }).isRequired,
  wompayCard: PropTypes.shape({
    maxAmount: PropTypes.number,
    patActivated: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    lastname: PropTypes.string,
    lastFour: PropTypes.string,
    vendor: PropTypes.string,
  }).isRequired,
  balance: PropTypes.number.isRequired,
  buyCallback: PropTypes.func.isRequired,
  disabledMethods: PropTypes.arrayOf(PropTypes.string),
  paymentType: PropTypes.string,
  fromOtherLines: PropTypes.bool.isRequired,
};

Buying.defaultProps = {
  disabledMethods: [],
  paymentType: 'bolsa',
};

export default Buying;
